import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import React, { FC, useState } from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { styled } from "@material-ui/styles";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: `1px solid ${theme.palette.brand.gray200}`,
      borderRadius: 8,
    },
    "&.Mui-focused fieldset": {
      border: `1px solid ${theme.palette.brand.blueAccent}`,
    },
  },
}));

type PasswordFieldProps = Omit<TextFieldProps, "type">;

const PasswordField: FC<PasswordFieldProps> = ({ label = "Password", ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <StyledTextField
      {...rest}
      label={label}
      type={showPassword ? "text" : "password"}
      variant="outlined"
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" size="small">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;
